import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations, getInitialLanguage } from './translations';
import { setCurrentLanguage, stopAllAudio } from './voiceUtils';
import { API } from './utils';

const GuestPortalContext = createContext(null);

export function GuestPortalProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const t = translations[language];

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    setCurrentLanguage(lang);
    localStorage.setItem('bitsy_language', lang);
  }, []);

  const toggleLanguage = useCallback(() => {
    setLanguage(language === 'en' ? 'es' : 'en');
  }, [language, setLanguage]);

  // Sync module-level language on mount
  useEffect(() => {
    setCurrentLanguage(language);
  }, [language]);

  return (
    <GuestPortalContext.Provider value={{ language, setLanguage, toggleLanguage, t, stopAllAudio, API }}>
      {children}
    </GuestPortalContext.Provider>
  );
}

export function useGuestPortal() {
  const ctx = useContext(GuestPortalContext);
  if (!ctx) throw new Error('useGuestPortal must be used within GuestPortalProvider');
  return ctx;
}
